{
  "common": {
    "search": "Search charts...",
    "no_results": "No charts found",
    "settings": "Settings",
    "description": "Description",
    "unsaved_changes": "Unsaved changes"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "analytics": "Analytics",
    "platformValue": "Platform Value",
    "customers": "Customers",
    "orders": "Orders",
    "products": "Products",
    "discounts": "Discounts",
    "features": "Features",
    "channels": "Channels",
    "templateStudio": "Template Studio",
    "aiUsage": "AI Usage",
    "costs": "Service Costs",
    "emailManager": "Email Manager",
    "demoRequests": "Demo Requests",
    "logs": "Logs",
    "auditTrail": "Audit Trail",
    "support": "Support",
    "settings": "Settings"
  },
  "actions": {
    "save": "Save",
    "publish": "Publish",
    "unpublish": "Unpublish"
  },
  "charts": {
    "preview_available": "Preview available",
    "titles": {
      "total_revenue": "Total Revenue",
      "total_expenses": "Total Expenses",
      "net_profit_kpi": "Net Profit",
      "orders_kpi": "Orders",
      "ad_spend_kpi": "Ad Spend",
      "aov_kpi": "Average Order Value",
      "net_profit_over_time": "Net Profit Over Time",
      "profit_waterfall": "Profit Waterfall",
      "profit_margin_over_time": "Profit Margin % Over Time",
      "income_vs_costs": "Income vs Costs",
      "daily_pl_table": "Daily P&L Table",
      "running_profit": "Running Profit",
      "profit_period_comparison": "Profit: This Period vs Last",
      "roas_by_platform": "ROAS by Platform",
      "roas_over_time": "ROAS Over Time",
      "blended_mer": "Marketing Efficiency (MER)",
      "ad_spend_percent": "Ad Spend as % of Revenue",
      "cpa_over_time": "Cost per Order Over Time",
      "campaign_roas_leaderboard": "Campaign Profitability Ranking",
      "ad_set_efficiency_scatter": "Ad Set Efficiency Map",
      "creative_performance_table": "Creative Performance Table",
      "ad_funnel": "Ad Funnel: Views → Clicks → Orders",
      "cpm_trend": "CPM Trend (Cost to Reach)",
      "cpc_trend": "Cost per Click Trend",
      "wasted_ad_spend": "Wasted Ad Spend",
      "ctr_over_time": "Click-Through Rate Over Time",
      "best_sellers_by_revenue": "Best Sellers by Revenue",
      "revenue_concentration": "Revenue Concentration (80/20)",
      "product_sales_trend": "Product Sales Trend",
      "units_sold_ranking": "Units Sold Ranking",
      "revenue_per_unit": "Revenue per Unit by Product",
      "product_return_rate": "Return Rate by Product",
      "refund_damage_by_product": "Refund Damage by Product",
      "product_channel_matrix": "Product × Channel Matrix",
      "expense_category_donut": "Expense Breakdown",
      "expense_category_trend": "Cost Category Trend",
      "payment_processing_fees": "Payment Processing Fees",
      "payment_fees_percent": "Payment Fees as % of Revenue",
      "shipping_cost_over_time": "Shipping Revenue Over Time",
      "shipping_per_order": "Average Shipping Revenue per Order",
      "discount_total_and_rate": "Discounts Given",
      "journal_expense_breakdown": "Custom Expense Breakdown",
      "journal_expenses_over_time": "Custom Expenses Over Time",
      "true_cost_per_order": "True Cost per Order",
      "expense_anomaly_detector": "Unusual Expense Spikes",
      "daily_inflows_outflows": "Daily Money In vs Out",
      "cumulative_cash_position": "Running Cash Balance",
      "ad_spend_vs_revenue_timing": "Ad Spend vs Revenue Timing",
      "weekly_cash_summary": "Weekly Cash Flow",
      "break_even_day": "Break-Even Day",
      "money_flow_sankey": "Money Flow Diagram",
      "return_rate_over_time": "Return Rate Over Time",
      "refund_amount_over_time": "Refund Amount Over Time",
      "refund_type_breakdown": "Refund Type Breakdown",
      "refund_true_cost": "True Cost of Refunds",
      "most_returned_products": "Most Returned Products",
      "paid_vs_organic_revenue": "Paid vs Organic Revenue",
      "paid_vs_organic_trend": "Paid vs Organic Trend",
      "revenue_by_utm_source": "Revenue by Traffic Source",
      "revenue_by_utm_campaign": "Revenue by Marketing Campaign",
      "unattributed_revenue": "Unattributed Revenue",
      "purchase_frequency": "Purchase Frequency",
      "top_customers_by_revenue": "Top Customers by Spend",
      "customer_concentration": "Customer Revenue Concentration",
      "new_vs_returning_revenue": "New vs Repeat Customer Revenue",
      "avg_revenue_per_customer": "Average Revenue per Customer",
      "revenue_period_comparison": "Revenue: This Period vs Last",
      "order_volume_over_time": "Order Volume Over Time",
      "aov_trend": "Average Order Value Trend",
      "revenue_vs_ad_spend_growth": "Revenue Growth vs Ad Spend Growth",
      "spend_vs_roas_scatter": "Spend vs Return Efficiency",
      "sales_by_day_of_week": "Sales by Day of Week",
      "revenue_forecast": "Revenue Forecast",
      "expense_forecast": "Expense Forecast",
      "profit_forecast": "Profit Forecast",
      "break_even_projection": "Break-Even Projection",
      "seasonal_index": "Best & Worst Performing Days",
      "what_if_simulator": "What-If Scenario",
      "activity_timeline": "Activity Timeline",
      "revenue_with_action_markers": "Revenue with Action Markers",
      "budget_change_impact": "Budget Change Impact",
      "budget_increase_efficiency": "Budget Increase Efficiency",
      "campaign_toggle_impact": "Campaign Launch & Pause Impact",
      "pause_resume_comparison": "Pause/Resume Performance",
      "creative_swap_performance": "Creative Swap Performance",
      "audience_change_impact": "Audience Change Impact",
      "ad_approval_tracker": "Ad Approval Tracker",
      "campaign_lifecycle": "Campaign Lifecycle View",
      "product_launch_performance": "Product Launch Performance",
      "product_removal_impact": "Product Removal Impact",
      "promo_discount_rule_impact": "Promotion & Discount Rule Impact",
      "refund_spike_analysis": "Refund Spike Analysis",
      "order_fulfillment_funnel": "Order Fulfillment Funnel",
      "cancellation_rate_over_time": "Cancellation Rate Over Time",
      "activity_volume_vs_revenue": "Activity Volume vs Revenue",
      "billing_issues_timeline": "Billing & Payment Issues",
      "action_breakdown_by_type": "Action Breakdown by Type",
      "before_after_any_action": "Before/After Any Action"
    }
  },
  "templates": {
    "studio": "Template Studio",
    "unsavedChanges": "Unsaved Changes",
    "saveDraft": "Save Template",
    "publishTemplate": "Publish Template",
    "templateSettings": "Template Settings",
    "viewOnDesktop": "Desktop",
    "viewOnTablet": "Tablet",
    "viewOnMobile": "Mobile",
    "empty_canvas_title": "Start Building Your Template",
    "empty_canvas_desc": "Drag charts from the catalog to build your standard dashboard layout.",
    "drag_from_catalog": "DRAG FROM CATALOG",
    "search_charts": "Search charts...",
    "drag_hint": "Drag to canvas",
    "discard_changes": "Discard Changes",
    "confirm_discard": "Are you sure you want to discard your changes?",
    "ai_assist_title": "Need help designing?",
    "ai_assist_body": "Automated layout suggestions coming soon",
    "simulator": "simulator"
  },
  "orders": {
    "details": "Order Details",
    "timeline": "Timeline",
    "customer": "Customer",
    "contactInfo": "Contact Information",
    "invoice": "Invoice",
    "viewInvoice": "View Invoice",
    "downloadPdf": "Download PDF",
    "refund": {
      "button": "Refund Order",
      "modalTitle": "Refund Order",
      "reason": "Reason",
      "amount": "Refund Amount (Optional)",
      "fullAmountHint": "Leave blank to refund the full amount.",
      "cancel": "Cancel",
      "confirm": "Confirm Refund",
      "processing": "Processing...",
      "failed": "Failed to refund order",
      "reasons": {
        "requested_by_customer": "Requested by Customer",
        "duplicate": "Duplicate",
        "fraudulent": "Fraudulent"
      }
    }
  }
}
